import React, { Component } from 'react'
import Radium from 'radium'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { Redirect } from 'react-router-dom'

class GenModal extends Component {

  state = {
    isModal: false,
    redirect: false
  }

  toggleModal = () => {
    const toggleState = !this.state.isModal
    this.setState({
      isModal: toggleState
    })
  }

  chooseYes = () => {
    if(this.props.yesFunc) {
      const flag = this.props.yesFunc()
      if(flag) {
        if(this.props.yesPath) {
          this.setState({
            redirect: true
          })
        } else {
          this.toggleModal()
        }
      }
    }
  }

  render() {
    if(this.state.redirect) {
      return <Redirect push to={this.props.yesPath} />
    }
    return(
      <div>
        <Button className={this.props.buttonClass} onClick={this.toggleModal}>{this.props.buttonLabel}</Button>
        <Modal isOpen={this.state.isModal} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>{this.props.title}</ModalHeader>
          <ModalBody><p>{this.props.body}</p></ModalBody>
          <ModalFooter style={modalFooterStyle}>
            <Button className="btn-danger" onClick={this.toggleModal}>No</Button>
            <Button className="btn-success" onClick={this.chooseYes}>Yes</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const modalFooterStyle = {
  display: 'flex',
  FlexDirection: 'row',
  justifyContent: 'space-between'
}

export default Radium(GenModal)
